import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Back to the gallery from a screen it opened: the entry before, so the
 * phone's own Back goes the same way and no screen is passed twice. Opened
 * any other way (a link, a reload), the gallery takes this entry's place, so
 * Back cannot return to a form that was just saved.
 *
 * Opened from the camera's post-capture summary (Edit details: fromCamera),
 * the entry before is the camera, and Back returns there instead.
 */
export function useBackToGallery() {
  const navigate = useNavigate();
  const location = useLocation();
  return () => (location.state?.fromGallery || location.state?.fromCamera
    ? navigate(-1) : navigate('/field/gallery', { replace: true }));
}

/** Whether useBackToGallery's Back leads to the camera (opened from its
 *  summary), so the button can say so: [label key, tip key]. */
export function useBackLabels() {
  const location = useLocation();
  return location.state?.fromCamera && !location.state?.fromGallery
    ? ['gallery.toCamera', 'tip.editor.backToCamera'] : ['editor.back', 'tip.editor.back'];
}
